import { render, staticRenderFns } from "./ErrorLabel.vue?vue&type=template&id=65d7ffe3&scoped=true&"
import script from "./ErrorLabel.vue?vue&type=script&lang=ts&"
export * from "./ErrorLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorLabel.vue?vue&type=style&index=0&id=65d7ffe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7ffe3",
  null
  
)

export default component.exports